import * as angular from 'angular';
import { Growl } from 'angular/custom/services/growl.service';
import { Modal } from '../custom';
import { SsoSettingsResource } from 'app/_resources/sso-settings.resource';
import { AuthService } from 'app/_services/auth.service';
import { ConfirmModal } from 'app/_services/confirm-modal.factory';
import { ErrorHandler } from 'app/_services/error-handler.factory';

enum PageState {
    SENDING,
    SUCCESS,
    ERROR
}

class StorageAdminFcfsServiceActivationComponentCtrl implements ng.IController {
    private readonly disableModal: Modal = {
        title: 'Are you sure you want to disable the PRISMA FCFS Service?',
        text: 'By disabling the PRISMA FCFS Service, you will not have access to this service.'
    };

    private readonly enableModal: Modal = {
        title: 'Are you sure you want to enable the PRISMA FCFS Service?',
        text:
            'If enabled, your company will have access to the FCFS booking service of PRISMA.' +
            '<BR/>By enabling you agree to the terms and conditions and the charges for the "PRISMA FCFS for SSO" Service.'
    };

    private loading: boolean = true;
    private togglingFcfsService: boolean;
    private fcfsServiceEnabled: boolean;
    private loadingErrorMsg: string;
    private authenticatedUser: LoginResult;
    public state: PageState;
    public ssoConfig: SsoConfigDto;
    public ssoConfigBackupReqUrl: string = '';
    public ssoConfigBackupCoUrl: string = '';
    public submitConfirmationErrorMessage: string = '';

    constructor(
        private ssoSettingsResource: SsoSettingsResource,
        private confirmModal: ConfirmModal,
        private authService: AuthService,
        private errorHandler: ErrorHandler,
        private growl: Growl
    ) {}

    $onInit() {
        this.loading = true;
        this.authService.userLoginPromise.promise.then(
            (loginResult: LoginResult) => {
                this.authenticatedUser = loginResult;

                this.ssoSettingsResource
                    .queryFcfsService(
                        { id: this.authenticatedUser.referenceId },
                        (res: SsoConfigDto) => {
                            this.ssoConfig = res;
                            this.ssoConfigBackupReqUrl =
                                this.ssoConfig.storageFcfsRequestUrl;
                            this.ssoConfigBackupCoUrl =
                                this.ssoConfig.storageFcfsConfirmUrl;
                            this.fcfsServiceEnabled =
                                this.ssoConfig.storageFcfsEnabled;
                        },
                        (err) => {
                            this.loadingErrorMsg =
                                err && err.data && err.data.message
                                    ? err.data.message
                                    : 'Something went wrong when loading the FCFS service settings.';
                        }
                    )
                    .$promise.finally(() => (this.loading = false));
            }
        );
    }

    public toggleFcfsService(): void {
        const unToggle: () => void = () => (this.togglingFcfsService = false);
        let result: angular.IPromise<any>;
        if (this.fcfsServiceEnabled) {
            result = this.openModal(this.disableModal);
        } else {
            result = this.openModal(this.enableModal);
        }

        result
            .then(() => {
                this.ssoSettingsResource
                    .saveFcfsServiceEnabled(
                        { id: this.authenticatedUser.referenceId },
                        !this.fcfsServiceEnabled,
                        (res: boolean) => {
                            this.growl.show(
                                'The Settings was successfully saved.',
                                'success'
                            );
                            this.fcfsServiceEnabled = res;
                            if (this.fcfsServiceEnabled) {
                                // load settings from last query
                                this.ssoConfig.storageFcfsRequestUrl =
                                    this.ssoConfigBackupReqUrl;
                                this.ssoConfig.storageFcfsConfirmUrl =
                                    this.ssoConfigBackupCoUrl;
                            }
                        },
                        this.errorHandler
                    )
                    .$promise.finally(unToggle);
            })
            .catch(unToggle);
    }

    public saveFcfsServiceUrls(): void {
        this.state = PageState.SENDING;
        this.ssoSettingsResource.saveFcfsServiceUrls(
            { id: this.authenticatedUser.referenceId },
            this.ssoConfig,
            () => {
                this.growl.show("The URL's are successfully saved.", 'success');
                this.state = PageState.SUCCESS;
                this.ssoConfigBackupReqUrl =
                    this.ssoConfig.storageFcfsRequestUrl;
                this.ssoConfigBackupCoUrl =
                    this.ssoConfig.storageFcfsConfirmUrl;
            },
            (err) => {
                const errorMessage =
                    err && err.data && err.data.message
                        ? err.data.message
                        : 'An unknown error occurred. Please, check back later.';
                this.submitConfirmationErrorMessage = errorMessage;
                this.state = PageState.ERROR;
            }
        );
    }

    public openModal(modal: Modal): angular.IPromise<any> {
        return this.confirmModal(modal.text, modal.title).result;
    }
}

angular.module('app').component('pkpStorageAdminFcfsServiceActivation', {
    controller: StorageAdminFcfsServiceActivationComponentCtrl,
    template:
        require('app/storage-admin/storage-admin-fcfs-service-activation.component.html'),
    bindings: {}
});
